/** AUTO GENERATED FROM "node ./src/utils/build-icons.js". DO NOT TOUCH. * */
import React from 'react';
import classNames from 'classnames';

class Icon extends React.PureComponent {
  render() {
    const { className, svgRef, ...otherProps } = this.props;
    return (
      <svg
        width="20.38"
        height="20.2"
        viewBox="0 0 20.38 20.2"
        fill="currentColor"
        className={classNames('nmx-icon', className)}
        ref={svgRef}
        {...otherProps}>
        <path
          d="M675.86,394.1l6.91-4.38,6.91,4.18-2-8,5.32-4.58-6.91-.87-3.32-6.55-3.3,6.57-6.85.87,5.27,4.56Zm-.9-12,5.17-.66,2.64-5.26,2.6,5.19v.07l5.21.66-4.06,3.46,1.59,6.25-5.27-3.22-.08,0-5.33,3.36,1.58-6.36Z"
          transform="translate(-672.62 -373.9)"
          className="icon-fill"/>
      </svg>
    );
  }
}

Icon.displayName = 'StarIcon';

export default Icon;
